export default "__VITE_ASSET__CaMZTrYK__"